import React, { useEffect, useRef, useState } from 'react';
import { Award, Lightbulb, Shield } from 'lucide-react';
import { stats } from '../data/mock';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [animatedStats, setAnimatedStats] = useState(stats.map(() => 0));
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      stats.forEach((stat, index) => {
        const numericValue = parseInt(stat.value.replace(/\D/g, ''));
        let current = 0;
        const increment = numericValue / 50;
        const timer = setInterval(() => {
          current += increment;
          if (current >= numericValue) {
            current = numericValue;
            clearInterval(timer);
          }
          setAnimatedStats((prev) => {
            const newStats = [...prev];
            const prefix = stat.value.startsWith('+') ? '+' : '';
            const suffix = stat.value.includes('%') ? '%' : '';
            newStats[index] = prefix + Math.floor(current) + suffix;
            return newStats;
          });
        }, 30);
      });
    }
  }, [isVisible]);

  return (
    <section id="nosotros" ref={sectionRef} className="py-24 bg-[#F2F2F2]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A192F] mb-4">
            Más de 30 años creando sombra con{' '}
            <span className="text-[#FFD700]">estilo y tecnología</span>
          </h2>
          <p className="text-lg text-[#0A192F]/80 max-w-3xl mx-auto leading-relaxed">
            En TOLSOL llevamos más de tres décadas protegiendo hogares, terrazas y negocios con soluciones de protección solar a medida.
            Fabricamos e instalamos toldos, pérgolas y lonas con sistemas de domótica y materiales de alta durabilidad, garantizando confort y eficiencia energética.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-[#FFD700]/20 rounded-full flex items-center justify-center mb-6">
              <Lightbulb className="w-8 h-8 text-[#FFD700]" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A192F] mb-4">Innovación</h3>
            <p className="text-[#0A192F]/70 leading-relaxed">
              Integración con tecnología inteligente para un control total y automatizado de tus sistemas de protección solar.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-[#FFD700]/20 rounded-full flex items-center justify-center mb-6">
              <Shield className="w-8 h-8 text-[#FFD700]" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A192F] mb-4">Durabilidad</h3>
            <p className="text-[#0A192F]/70 leading-relaxed">
              Resistencia al sol y viento con materiales certificados. Garantía de 2 años en todos nuestros productos.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-[#FFD700]/20 rounded-full flex items-center justify-center mb-6">
              <Award className="w-8 h-8 text-[#FFD700]" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A192F] mb-4">Confianza</h3>
            <p className="text-[#0A192F]/70 leading-relaxed">
              Miles de clientes satisfechos en toda España. Profesionalidad y experiencia en cada instalación.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-[#FFD700] mb-2">
                {animatedStats[index]}
              </div>
              <div className="text-lg text-[#0A192F] font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;